import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    date,
    agencyName,
    agencyTax,
    sendTo,
  },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [date.name]: "",
  [agencyName.name]: "",
  [agencyTax.name]: "",
  [sendTo.name]: "",
};

export default initialValues;
